import { Box, IconButton, Image, Text } from '@chakra-ui/react'
import nygovlogo from '../assets/nygov-logo.png'
import { HiMenu } from "react-icons/hi";
import { LuLogOut } from "react-icons/lu";
import { useColorPalette } from './ui/color-palette-context';
import { logout } from '@/api';

interface NavbarProps {
    onMenuClick?: () => void;
    fontFamily?: string;
    [key: string]: any;
}

export const Navbar = (props: NavbarProps) => {
    const { onMenuClick, fontFamily, ...rest } = props;
    const { colorPalette } = useColorPalette();

    const handleLogout = async () => {
        try {
            const { redirectUrl } = await logout();
            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        } catch (error) {
            console.error('Logout failed:', error);
        }
    }

    return (
        <Box 
            role='navigation' 
            fontFamily={fontFamily} 
            bg={`${colorPalette}.solid`} 
            height={'64px'} 
            display={'flex'} 
            justifyContent={'space-between'} 
            alignItems={'center'} 
            px="4"
            {...rest}
        >
            <Box display={'flex'} gap={'4'} alignItems={'center'}>
                <IconButton 
                    aria-label="Open Menu" 
                    variant="ghost" 
                    color="white" 
                    onClick={onMenuClick}
                    _hover={{ bg: 'whiteAlpha.200' }}
                >
                    <HiMenu size="24px" />
                </IconButton>
                <Box display="flex" alignItems="center" gap="3" divideX="1px" divideColor="whiteAlpha.400">
                    <Image height={'32px'} filter={'brightness(0) invert(100%)'} src={nygovlogo} alt='NYS Logo' />
                    <Box pl="3">
                        <Text fontWeight={'600'} lineHeight={'shorter'} fontSize={'md'} color={'white'}>AI Assist</Text>
                    </Box>
                </Box>
            </Box>
            <IconButton 
                aria-label='Logout' 
                onClick={handleLogout} 
                size={'md'} 
                variant={'ghost'} 
                borderRadius={'full'} 
                color={'white'} 
                _hover={{ bg: 'whiteAlpha.200' }} 
            >
                <LuLogOut />
            </IconButton>
        </Box>
    )
}
